export default __webpack_public_path__ + "static/media/transiluminator-switch-on.dd911526.svg";